import React, { useEffect, useState, useCallback, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import apiUrl from "../../Environment/Api";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Invoice() {
  const navigate = useNavigate();

  //get
  const [getData, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const getdata = useCallback(async () => {
    try {
      const response = await axios.get(apiUrl + "/invoicedetails");
      if (response) {
        console.log("invoice data getted", response.data);
        setData(response.data);
        setFilteredData(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  }, []);

  const [getclientdetails, setclientdetails] = useState([]);
  const clientdetails = async () => {
    try {
      const response = await axios.get(apiUrl + "/clientdetails");
      setclientdetails(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getdata();
    clientdetails();
  }, []);

  const handleButtonClick = () => {
    navigate("/invoiceadd");
  };

  const [invoiceId, setInvoiceId] = useState("");

  const [formData1, setFormData1] = useState({
    invoiceId: "",
    clientName: "",
    paymentStatus: "",
    paymentDate: "",
  });
  const handleStatusButtonClick = (id) => {
    setShowModal1(true);
    setInvoiceId(id);
    const invoicetoUpdate = getData.find((item) => item.id === id);
    console.log("previous data", invoicetoUpdate);

    setFormData1({
      invoiceId: invoicetoUpdate.invoiceId,
      clientName: invoicetoUpdate.clientName,
      paymentStatus: invoicetoUpdate.paymentStatus,
      paymentDate: invoicetoUpdate.paymentDate,
    });
  };

  //update
  const [showModal1, setShowModal1] = useState(false);

  const handleCloseModal1 = () => {
    setShowModal1(false);
  };

  const handleupdatesubmit = async (e) => {
    e.preventDefault();
    try {
      if (formData1.paymentStatus === "Unpaid") {
        formData1.paymentDate = "";
      }
      const response = await axios.put(
        apiUrl + `/invoicedetails/${invoiceId}`,
        formData1
      );
      console.log("posted", response);
      setData({
        invoiceId: "",
        clientName: "",
        paymentStatus: "",
        paymentDate: "",
      });
      handleCloseModal1();
      getdata();
      toasterupdate();
    } catch (err) {
      console.log("error", err);
    }
  };

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [getDeleteId, setDeleteId] = useState(false);
  const [clientnamedelete, setclientnamedelete] = useState("");
  const [invoicenodelete, setinvoicenodelete] = useState("");
  const handledeletepopup = (clientname, invoiceno) => {
    setShowDeleteModal(true);
    setDeleteId(invoiceno);
    setclientnamedelete(clientname);
    setinvoicenodelete(invoiceno);
  };
  const handledeleteclose = () => {
    setShowDeleteModal(false);
  };

  //delete
  const handledelete = async () => {
    try {
      const response = await axios.delete(
        apiUrl + `/invoicedetails/${getDeleteId}`
      );
      console.log(response);
      getdata();
      toasterdelete();
    } catch (error) {
      console.log(error);
    }
    setShowDeleteModal(false);
  };

  const handlesearchFilter = (e) => {
    e.preventDefault();
    const inputValue = e.target.value.trim().toLowerCase();
    const filteredData = getData.filter((data) =>
      Object.values(data).some((value) =>
        value.toString().toLowerCase().includes(inputValue)
      )
    );
    setFilteredData(filteredData);
  };

  const [currentPage, setCurrentPage] = useState(1);
  // const [itemsPerPage] = useState(10);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Pagination calculation
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData
    .slice()
    .reverse()
    .slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Previous page
  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Next page
  const handleNextPage = () => {
    if (currentPage < Math.ceil(filteredData.length / itemsPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handleItemsPerPageChange = (e) => {
    setCurrentPage(1);
    setItemsPerPage(Number(e.target.value));
  };

  const tableRef = useRef(null);

  const toasterupdate = () => {
    toast.success("Data Updated successfully!", {
      autoClose: 3000,
      hideProgressBar: true,
      className: "toast-warning1",
    });
  };

  const toasterdelete = () => {
    toast.success("Data Deleted successfully!", {
      autoClose: 3000,
      hideProgressBar: true,
      className: "toast-error",
    });
  };

  const handleprint = (invoiceId) => {
    navigate(`/invoice/invoicebill/${invoiceId}`, {
      state: {
        invoice: { status: "print" },
      },
    });
  };
  const handlepdf = (invoiceId) => {
    navigate(`/invoice/invoiceprint/${invoiceId}`, {});
  };
  const handleEdit = (invoiceId) => {
    navigate(`/invoice/invoiceupdate/${invoiceId}`);
    console.log("edit id", invoiceId);
  };

  const formatDate = (dateString) => {
    if (!dateString || dateString === "Invalid Date") {
      return "";
    }

    const date = new Date(dateString);
    const formattedDate = date
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
      .replace(/\//g, "-");

    return formattedDate;
  };

  return (
    <>
      <ToastContainer />
      <div className="d-flex">
        <h5 className="mt-2">Invoice</h5>
        <button
          className="btn btn-success mx-3 addbutton-heading"
          onClick={handleButtonClick}
        >
          ADD
        </button>
      </div>
      <hr />
      <div>
        {/* //update */}
        <Modal className="modal" show={showModal1} onHide={handleCloseModal1}>
          <form onSubmit={handleupdatesubmit}>
            <Modal.Header closeButton>
              <Modal.Title>Payment Status Update</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <label className="form-label">
                <b>Invoice No</b>
              </label>
              <input
                className="form-control"
                type="text"
                value={formData1.invoiceId}
              ></input>
              <label className="form-label">
                <b>Client Name</b>
              </label>
              <select value={formData1.clientName} className="form-control">
                <option>{formData1.clientName}</option>
              </select>
              <label className="form-label">
                <b>Payment Status</b>
              </label>
              <div className="position-relative">
                <select
                  value={formData1.paymentStatus}
                  className="form-control dropdown-toggle custom-select"
                  onChange={(e) => {
                    setFormData1({
                      ...formData1,
                      paymentStatus: e.target.value,
                    });
                  }}
                  required
                >
                  <option value="">Select</option>
                  <option value="Paid">Paid</option>
                  <option value="Unpaid">Unpaid</option>
                </select>
                <div className="dropdown-arrow"></div>
              </div>
              {formData1.paymentStatus === "Paid" && (
                <>
                  <label className="form-label mt-3 ">
                    <b>Payment Date</b>
                  </label>
                  <input
                    className="form-control"
                    type="date"
                    value={formData1.paymentDate}
                    onChange={(e) => {
                      setFormData1({
                        ...formData1,
                        paymentDate: e.target.value,
                      });
                    }}
                    required
                  />
                </>
              )}
            </Modal.Body>

            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseModal1}>
                Close
              </Button>
              <Button variant="primary" type="submit">
                Update
              </Button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>

      {/* Delete */}
      <Modal show={showDeleteModal} onHide={handledeleteclose}>
        <Modal.Header>
          <Modal.Title>
            {" "}
            <div className="row">
              <div className="col-lg-2 d-flex justify-content-center pt-2">
                <img
                  className="trash"
                  src={require("../../../assets/img/Admin/bin.png")}
                  alt="images"
                />
              </div>
              <div className="col-lg-10">
                {" "}
                <p className="popup-delete-text mt-2">
                  Are you sure you want to delete ?
                </p>
                <h6>Invoice No : {invoicenodelete}</h6>
                <h6>Client Name : {clientnamedelete}</h6>
              </div>
            </div>{" "}
          </Modal.Title>
        </Modal.Header>
        <Modal.Footer>
          <Button variant="secondary" onClick={handledeleteclose}>
            Close
          </Button>
          <Button variant="danger" type="submit" onClick={handledelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="d-flex justify-content-between">
        <div className="mx-2">
          <label>Show per page:</label>
          <select
            className="form-control"
            value={itemsPerPage}
            onChange={handleItemsPerPageChange}
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={200}>200</option>
            <option value={500}>500</option>
          </select>
        </div>
        <form>
          <label>Search :</label>
          <input
            className="form-control"
            type="text"
            onChange={handlesearchFilter}
          ></input>
        </form>
      </div>

      <div className="invoicebackground mt-3">
        <div className="table-responsive table-responsive-data2">
          <table ref={tableRef} class="table table-striped">
            <thead>
              <tr className="tr-heading">
                <th>S.No</th>
                <th>Date</th>
                <th>Invoice No</th>
                <th>Client Name</th>
                <th>Total Amount</th>
                <th>Payment Status</th>
                <th>Payment Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.map((data, index) => (
                <tr key={index} className="tr-shadow">
                  <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                  <td>{formatDate(data.date)}</td>
                  <td>{data.invoiceId}</td>
                  <td>{data.clientName}</td>
                  <td>
                    {(() => {
                      const clientData = getclientdetails.find(
                        (client) => client.id === data.clientId
                      );

                      if (clientData) {
                        const currencySymbol =
                          clientData.countrycode === "91" ? "₹" : "$";
                        return (
                          <span>
                            {currencySymbol}{" "}
                            {Number(data.totalAmount).toFixed(2)}
                          </span>
                        );
                      }
                      return null;
                    })()}
                  </td>
                  <td>{data.paymentStatus}</td>
                  <td>{formatDate(data.paymentDate)}</td>
                  <td>
                    <button
                      className={`btn btn-button mx-2 px-2 editbutton ${
                        data.paymentStatus === "Paid" ? "disabled" : ""
                      }`}
                      onClick={() => handleEdit(data.invoiceId)}
                    >
                      <i class="fa-solid fa-pen-to-square"></i>
                    </button>
                    <button
                      className="btn btn-primary px-2 mx-2 printbutton"
                      onClick={() => handlepdf(data.invoiceId)}
                    >
                      <i class="fa-regular fa-file-pdf"></i>
                    </button>
                    {/* <button className='btn btn-secondary px-2 mx-2 print1button' onClick={() => handleprint(data.invoiceId)}>
          <i className="fa-solid fa-print" ></i>
        </button> */}
                    <button
                      className="btn btn-sucess px-2 mx-2 statusbutton"
                      onClick={() => handleStatusButtonClick(data.id)}
                    >
                      <i className="fa-solid fa-sack-dollar"></i>
                    </button>
                    <button
                      className="btn btn-button px-2 mx-2 deletebutton"
                      onClick={() =>
                        handledeletepopup(data.clientName, data.invoiceId)
                      }
                    >
                      <i class="fa-solid fa-trash"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* <div className='d-flex justify-content-end mx-5'>
            <label className='mx-5 totallabel'>
              Total:
            </label>
            <p className='mx-5 totallabel'>{totalAmount}</p>
          </div> */}
          <div>
            <nav className="d-flex justify-content-end mx-2 pt-3">
              <ul className="pagination">
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <button className="page-link mx-3" onClick={handlePrevPage}>
                    Previous
                  </button>
                </li>
                {Array.from(
                  { length: Math.ceil(filteredData.length / itemsPerPage) },
                  (_, index) => (
                    <li
                      key={index}
                      className={`page-item ${
                        currentPage === index + 1 ? "active" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => paginate(index + 1)}
                      >
                        {index + 1}
                      </button>
                    </li>
                  )
                )}
                <li
                  className={`page-item ${
                    currentPage ===
                    Math.ceil(filteredData.length / itemsPerPage)
                      ? "disabled"
                      : ""
                  }`}
                >
                  <button className="page-link mx-3" onClick={handleNextPage}>
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </>
  );
}

export default Invoice;
